import { ArrowTrendingTextFilled, ArrowTrendingTextRegular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const JobMgmtApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "JobMgmtApp" */ "./JobMgmtApp");
    return { default: namedExport.JobMgmtApp };
});

export const JobMgmt: TeamAppConfig = {
    title: "Job Mgmt",
    regularIcon: ArrowTrendingTextRegular,
    filledIcon: ArrowTrendingTextFilled,
    path: "/JobMgmt",
    description: "Osp Job Management App",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: JobMgmtApp
};
